import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import BackdropLoading from "../../components/BackdropLoading";

// Importar os dois tipos de Dashboard
import DashboardClassic from "./DashboardClassic";
import DashboardModern from "./DashboardModern";

/**
 * Dashboard Selector
 * 
 * Seleciona automaticamente o Dashboard baseado no tipo de layout:
 * - Layout Clássico → Dashboard Clássico (atual)
 * - Layout Moderno → Dashboard Moderno (novo)
 */
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const { get: getSetting } = useCompanySettings();
  const [layoutType, setLayoutType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLayoutType = async () => {
      try {
        if (user?.companyId) {
          const setting = await getSetting({
            column: "layoutType"
          });
          
          if (setting && setting.layoutType) {
            setLayoutType(setting.layoutType);
          } else {
            setLayoutType("classic");
          }
        } else {
          setLayoutType("classic");
        }
      } catch (error) {
        console.log("Erro ao buscar layoutType para Dashboard:", error);
        setLayoutType("classic");
      } finally {
        setLoading(false);
      }
    };

    const timer = setTimeout(() => {
      fetchLayoutType();
    }, 50);

    return () => clearTimeout(timer);
  }, [getSetting, user?.companyId]);

  if (loading || !layoutType) {
    return <BackdropLoading />;
  }

  // Renderiza o Dashboard apropriado baseado no layout
  if (layoutType === "modern") {
    return <DashboardModern />;
  }

  return <DashboardClassic />;
};

export default Dashboard;
